import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css'

import AnnouncementIcon from '@/components/icons/AnnouncementIcon'
import BadgeIcon from '@/components/icons/BadgeIcon'
import ButtonIcon from '@/components/icons/ButtonIcon'
import CampaignIcon from '@/components/icons/CampaignIcon'
import CancelIcon from '@/components/icons/CancelIcon'
import CartIcon from '@/components/icons/CartIcon'
import CheckIcon from '@/components/icons/CheckIcon'
import ConsumeIcon from '@/components/icons/ConsumeIcon'
import DividerIcon from '@/components/icons/DividerIcon'
import DropDownIcon from '@/components/icons/DropDownIcon'
import EatIcon from '@/components/icons/EatIcon'
import EditIcon from '@/components/icons/EditIcon'
import FlagIcon from '@/components/icons/FlagIcon'
import FlaskIcon from '@/components/icons/FlaskIcon'
import FeedbackIcon from '@/components/icons/FeedbackIcon'
import GalleryIcon from '@/components/icons/GalleryIcon'
import GiftIcon from '@/components/icons/GiftIcon'
import HeartIcon from '@/components/icons/HeartIcon'
import ImageIcon from '@/components/icons/ImageIcon'
import KeyIcon from '@/components/icons/KeyIcon'
import LeafIcon from '@/components/icons/LeafIcon'
import MixIcon from '@/components/icons/MixIcon'
import MoreIcon from '@/components/icons/MoreIcon'
import NutritionIcon from '@/components/icons/NutritionIcon'
import PreviewIcon from '@/components/icons/PreviewIcon'
import RecycleIcon from '@/components/icons/RecycleIcon'
import RemoveIcon from '@/components/icons/RemoveIcon'
import ShareIcon from '@/components/icons/ShareIcon'
import SocialIcon from '@/components/icons/SocialIcon'
import StarIcon from '@/components/icons/StarIcon'
import SustainabilityIcon from '@/components/icons/SustainabilityIcon'
import TextIcon from '@/components/icons/TextIcon'
import ToolsIcon from '@/components/icons/ToolsIcon'
import TrashIcon from '@/components/icons/TrashIcon'
import TrackAndTraceIcon from '@/components/icons/TrackAndTraceIcon'
import TypeformIcon from '@/components/icons/TypeformIcon'
import VideoIcon from '@/components/icons/VideoIcon'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      announcement: {
        component: AnnouncementIcon
      },
      badge: {
        component: BadgeIcon
      },
      button: {
        component: ButtonIcon
      },
      cart: {
        component: CartIcon
      },
      campaign: {
        component: CampaignIcon
      },
      cancel: {
        component: CancelIcon
      },
      check: {
        component: CheckIcon
      },
      consume: {
        component: ConsumeIcon
      },
      'drop-down': {
        component: DropDownIcon
      },
      divider: {
        component: DividerIcon
      },
      eat: {
        component: EatIcon
      },
      edit: {
        component: EditIcon
      },
      feedback: {
        component: FeedbackIcon
      },
      flag: {
        component: FlagIcon
      },
      flask: {
        component: FlaskIcon
      },
      gallery: {
        component: GalleryIcon
      },
      gift: {
        component: GiftIcon
      },
      heart: {
        component: HeartIcon
      },
      image: {
        component: ImageIcon
      },
      key: {
        component: KeyIcon
      },
      leaf: {
        component: LeafIcon
      },
      mix: {
        component: MixIcon
      },
      more: {
        component: MoreIcon
      },
      nutrition: {
        component: NutritionIcon
      },
      preview: {
        component: PreviewIcon
      },
      recycle: {
        component: RecycleIcon
      },
      remove: {
        component: RemoveIcon
      },
      share: {
        component: ShareIcon
      },
      social: {
        component: SocialIcon
      },
      star: {
        component: StarIcon
      },
      sustainability: {
        component: SustainabilityIcon
      },
      text: {
        component: TextIcon
      },
      tools: {
        component: ToolsIcon
      },
      trash: {
        component: TrashIcon
      },
      'track-and-trace': {
        component: TrackAndTraceIcon
      },
      typeform: {
        component: TypeformIcon
      },
      video: {
        component: VideoIcon
      }
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#15bbf0',
        secondary: '#15bbf0',
        accent: '#15bbf0'
      }
    }
  }
})
